/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.card {
  margin-top: calc(var(--spacing, 0.25rem) * 2);
  padding: calc(var(--spacing, 0.25rem) * 4);
  display: grid;
  align-items: center;
}
.animation {
  animation: slide-out 0.5s;
}
@keyframes slide-out {
  0% {
    transform: translateX(0);
    opacity: 0;
  }
  100% {
    transform: translateX(100%);
    opacity: 1;
  }
}
